import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController,AlertController } from 'ionic-angular';
import { B07aInvoiceInfoPage } from '../b07a-invoice-info/b07a-invoice-info';
import { B07bInvoiceAddPage } from '../b07b-invoice-add/b07b-invoice-add';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B07InvoicePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface invoiceInfo{
  INVOICE_ID: number;
  DATETIME: string;
  GRANDTOTAL: number; 
  REMARKS: string; 
  FINALIZED_FLG: string; 

  INV_CORP_ID: number;  
  CORP_NAME: string;
  ACTION_BY: number;
  USER_ID: number;
  USER_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b07-invoice',
  templateUrl: 'b07-invoice.html',
})
export class B07InvoicePage {

  loading: any;
  Status: any;
  invoiceArr: invoiceInfo[] = [];
  invoiceItems: invoiceInfo[] = [];
  public errorMessage: any = "";
  public searchMessage:any ="";
  GRP_ID: any;
  BRANCH_ID: any;
  invoiceNumber: any = "";
  status:any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, public alert:AlertController,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {

    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.BRANCH_ID = sessionStorage.getItem('userbranchid');

    let sortby= "INVOICE_ID";
    let sorttype= "DESC";

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["INV_CORP_ID", "ACTION_BY"];
    let fktbl = ["CORPORATE", "USER"];
    let fkkey = ["CORP_ID", "USER_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    
    this.serviceapi.readdata(json_data,"INVOICE","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        let Records = result["Records"];
        this.invoiceArr = Records;
        this.invoiceItems = this.invoiceArr;


      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }

    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B07InvoicePage');
  }

  edit(ID){
    this.navCtrl.push(B07aInvoiceInfoPage, {paramID: ID});            //invoice ID
  }

  newInvoice(){
    this.navCtrl.push(B07bInvoiceAddPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
  showLoader1(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...'
    });
    this.loading.present();
  }
  clearItem(){
    this.invoiceNumber = "";
    this.status = "";
  }

  searchItem(){
    this.searchMessage="";
    this.errorMessage="";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];
    this.invoiceItems = [];

    let sortby= "No";
    let sorttype= "No";

    if (this.invoiceNumber!=""){
      temp_tbl = ["INVOICE"];
      temp_column = ["INVOICE_ID"];
      temp_value = [this.invoiceNumber];

      this.status="";
    }
    else if (this.status!=""){
      temp_tbl = ["INVOICE"];
      temp_column = ["FINALIZED_FLG"];
      temp_value = [this.status];

      this.invoiceNumber = "";
    }
    else {
      temp_tbl = ["All"];
      temp_column = ["All"];
      temp_value = ["All"];
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["INV_CORP_ID", "ACTION_BY"];
    let fktbl = ["CORPORATE", "USER"];
    let fkkey = ["CORP_ID", "USER_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    
    this.serviceapi.readdata(json_data,"INVOICE","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        let Records = result["Records"];
        this.invoiceArr = Records;
        this.invoiceItems = this.invoiceArr;
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }

    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }
  newInvoiceAll()
  {
    let alertpop = this.alert.create({
      title: 'Issue All Invoice',
      message: 'Do you want to issue all invoice for last month?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.showLoader1();
            let USER_ID = sessionStorage.getItem('userid');

            let value = {
              Param:"",
              UserID:"",
            
            }
            value.Param = "1";
            value.UserID = USER_ID;
              this.serviceapi.invociedataall(value).then((result) => {
                this.loading.dismiss();
                this.Status = result["Message"];
              
                if (this.Status == '1'){
                  
                  let alert2 = this.alert.create({
                      title: 'Done',
                      subTitle: 'All Invoice Issue',
                      buttons: ['Dismiss']
                    });
                    alert2.present();
                    this.navCtrl.setRoot(B07InvoicePage);
                }
                else {
                
                }
              }, (err) => {
              
                this.loading.dismiss();
              });
          }
        }
      ]
    });
    alertpop.present();
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/b07-invoice/b07-invoice.ts